/**
 * Identity API
 * A production-ready Clean Architecture template for .NET 10 by Mukesh Murugan
 *
 * OpenAPI spec version: v1
 * Contact: sidcmisdepartment@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RegisterCommand { 
    firstName?: string;
    lastName?: string;
    email?: string;
    userName?: string;
    employeeCode?: string;
    password?: string;
    confirmPassword?: string;
}